import React, { useState, useEffect } from 'react';
import { Github, Linkedin, Mail, ExternalLink, Moon, Sun } from 'lucide-react';
// Import gambar
import LinuxHackingId from '../assets/linuxhackingid.jpg'; // Pastikan path ini benar
import PyconApac from '../assets/pycon-apac.png'; // Pastikan path ini benar


const Portfolio = () => {
  // State for dark mode
  const [darkMode, setDarkMode] = useState(false);
  
  // State for animations
  const [isVisible, setIsVisible] = useState({});

  // Animation observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(prev => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting
          }));
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('section').forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  // Original data
  const projects = [
    {
      title: "Project 1 (Trenzo Exchange)",
      description: "Aplikasi web menggunakan React & Node.js",
      tags: ["React", "Node.js", "MongoDB"],
      link: "https://github.com/dicky-awan-saputra/trenzo", // URL valid
    },
    {
      title: "Project 2 (Trenzo Wallet)",
      description: "Mobile app wallet untuk menyimpan aset crypto dengan react native",
      tags: ["React Native", "Firebase"],
      link: "https://trenzo-wallet.com", // URL valid 
    },
    {
      title: "Project 3 (Panda Store)",
      description: "Mobile app dengan Flutter",
      tags: ["Flutter", "Firebase"],
      link: "https://panda-store.com", // URL valid
    },
    {
      title: "Project 4 (Jason Technology Academy)",
      description: "Website Akademi",
      tags: ["React", "Redux", "Express"],
      link: "https://github.com/username/project3", // URL valid
    },
  ];
  

  const skills = [
    "HTML/CSS", "CSS", "JavaScript", "PHP", "Dart", "Python", "React", "Node.js", 
    "Git", "MongoDB", "SQL", "REST API", "Machine Learning", "Deep Learning"
  ];

  // Data untuk section baru
  const blogPosts = [
    {
      title: "Universitas Nahdalatul Ulama Yogyakarta",
      date: "2022-2026",
      excerpt: "Informatika",
    },
    {
      title: "SMK Darusalam 2",
      date: "2018-2021",
      excerpt: "Rekayasa Perangkat Lunak",
    }
  ];

  const testimonials = [
    {
      name: "Argo Computer",
      role: "Karyawan PKL",
      content: "Outstanding work and great communication"
    },
    {
      name: "Jasa Servis PC/Mobile",
      role: "Personal",
      content: "Install Ulang OS, Ganti LCD, dll"
    }
  ];

  const achievements = [
    {
      title: "BUG SQL INJECTION",
      date: "2024",
      issuer: "Linuxhackingid",
      image: "LinuxHackingId"
    },
    {
      title: "Panitia Streaming Event Pycon Apac",
      date: "2024",
      issuer: "Pycon Apac",
      image: "PyconApac"
    }
  ];

  const [showImage, setShowImage] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-50'} transition-colors duration-300`}>
      {/* Dark Mode Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <button
          onClick={() => setDarkMode(!darkMode)}
          className={`p-2 rounded-full ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-gray-200'}`}
        >
          {darkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>

      {/* Hero Section with Animation */}
      <header className={`${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-sm`}>
        <div className="max-w-4xl mx-auto px-4 py-16">
          <div className="transform transition-all duration-1000 translate-y-0">
            <h1 className="text-4xl font-bold mb-4">
              Dicky Awan Saputra
            </h1>
            <p className={`text-xl ${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-6`}>
              Specialist of Frontend Developer
            </p>
            <p>
                Generalist of Backend Developer, Full Stack Developer, & Blockchain Developer
            </p>
            <div className="flex gap-4">
              <a href="#" className={`${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`}>
                <Github size={24} />
              </a>
              <a href="#" className={`${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`}>
                <Linkedin size={24} />
              </a>
              <a href="mailto:email@example.com" className={`${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`}>
                <Mail size={24} />
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* About Section with Animation */}
      <section id="about" className={`py-16 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['about'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Tentang Saya</h2>
            <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Seorang passionate developer dengan pengalaman dalam pengembangan web modern.
              Fokus pada pembuatan aplikasi yang scalable dan user-friendly dengan
              teknologi terkini.
            </p>
          </div>
        </div>
      </section>

      {/* Skills Section with Animation */}
      <section id="skills" className={`py-16 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['skills'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Skills</h2>
            <div className="flex flex-wrap gap-3">
              {skills.map((skill, index) => (
                <span
                  key={index}
                  className={`px-4 py-2 rounded-full text-sm font-medium ${
                    darkMode 
                      ? 'bg-gray-800 text-gray-300' 
                      : 'bg-white text-gray-700'
                  } shadow-sm`}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section with Animation */}
      <section id="projects" className={`py-16 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['projects'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Projects</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {projects.map((project, index) => (
                <div 
                  key={index} 
                  className={`rounded-lg p-6 ${
                    darkMode ? 'bg-gray-900' : 'bg-gray-50'
                  } shadow-sm hover:shadow-md transition-shadow duration-300`}
                >
                  <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                  <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-4`}>
                    {project.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tags.map((tag, tagIndex) => (
                      <span
                        key={tagIndex}
                        className={`px-3 py-1 rounded-full text-xs font-medium ${
                          darkMode 
                            ? 'bg-gray-800 text-gray-300' 
                            : 'bg-gray-200 text-gray-700'
                        }`}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <a
                    href={project.link}
                    className="inline-flex items-center text-blue-500 hover:text-blue-600"
                  >
                    Lihat Project <ExternalLink size={16} className="ml-1" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section id="blog" className={`py-16 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['blog'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Blog Posts</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {blogPosts.map((post, index) => (
                <div 
                  key={index}
                  className={`rounded-lg p-6 ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                  } shadow-sm hover:shadow-md transition-shadow duration-300`}
                >
                  <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {post.date}
                  </span>
                  <h3 className="text-xl font-semibold mt-2 mb-3">{post.title}</h3>
                  <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                    {post.excerpt}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className={`py-16 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['testimonials'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Testimonials</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index}
                  className={`rounded-lg p-6 ${
                    darkMode ? 'bg-gray-900' : 'bg-gray-50'
                  } shadow-sm hover:shadow-md transition-shadow duration-300`}
                >
                  <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-4`}>
                    "{testimonial.content}"
                  </p>
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className={`${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section id="achievements" className={`py-16 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <div className="max-w-4xl mx-auto px-4">
          <div className={`transform transition-all duration-1000 ${isVisible['achievements'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-2xl font-bold mb-6">Achievements</h2>
            <div className="space-y-4">
              {achievements.map((achievement, index) => (
                <div key={index} className={`rounded-lg p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-sm hover:shadow-md transition-shadow duration-300`}>
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="text-xl font-semibold">{achievement.title}</h3>
                      <p className={`${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {achievement.issuer}
                      </p>
                    </div>
                    <span className={`px-3 py-1 rounded-full ${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`}>
                      {achievement.date}
                    </span>
                    {/* Tombol untuk menampilkan pop-up */}
                    <button onClick={() => {
                      setShowImage(true);
                      setSelectedImage(achievement.image);
                    }}>
                      Lihat Sertifikat
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Pop-up Gambar */}
      {showImage && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-4 relative">
            <img src={selectedImage} alt={achievements.find(ach => ach.image === selectedImage)?.title || ''} className="max-w-full max-h-full" />
            {/* Tombol Close */}
            <button onClick={() => setShowImage(false)} className="absolute top-2 right-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Contact Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Kontak
          </h2>
          <p className="text-gray-600 mb-4">
            Tertarik untuk berkolaborasi? Silakan hubungi saya melalui:
          </p>
          <div className="flex flex-col gap-2">
            <a href="mailto:dickyawansaputra2003@gmail.com" className="text-blue-600 hover:text-blue-800">
              dickyawansaputra2003@gmail.com
            </a>
            <a href="https://www.linkedin.com/in/dicky-awan-saputra-573703328/" className="text-blue-600 hover:text-blue-800">
              LinkedIn
            </a>
            <a href="https://www.upwork.com/freelancers/~01ed60cf34531f6e58" className="text-blue-600 hover:text-blue-800">
              Upwork
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};


export default Portfolio;